var plugin_default = {
  "alignLeft": "JfuDg",
  "textWrapNowrap": "_2tUGL",
  "alignRight": "L55ul",
  "alignCenter": "j2P7p",
  "sizeFullWidth": "_5RrMB",
  "renderedInTable": "ngvCs",
  "sizeOriginal": "RKEP0",
  "sizeContent": "_9pun9",
  "sizeSmall": "uTrxg",
  "sizeSmallCenter": "hI1cU",
  "flex": "XBbbK",
  "atomic": "OF6m9",
  "embed": "Iweiw",
  "horizontalScrollbar": "b7z1b",
  "pluginContainerMobile": "rafkR"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
